import { useState } from 'react';
import cn from 'classnames';
import style from './emailReceipt.module.scss';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';


const EmailReceipt = (props) => {
    const { setPopup, onSubmit } = props;
    const [email, setEmail] = useState(null);
    const [error, setError] = useState('');
    const validateEmail = email => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    const handleDone = () => {
      let isValid = false;
      isValid = validateEmail(email);

      if(isValid){
         onSubmit(email)
      }else{
        setError(FLABEL().RECEIPT_ERROR_EMAIL)
      }
    }
    return (
        <div className={cn("w-100 h-100", style.emailContainer)}>
            <div className="w-100 h-100 position-relative">
                <div className={cn("d-flex flex-column mb-6", style.emailInputConatiner)}>
                    <label className={cn("block fs-12 mb-0", style.emailHeader)}>{FLABEL().RECEIPT_EMAIL_ADDRESS}</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={cn("w-full focus:border-blue-500 focus:outline-none placeholder-gray-500", style.emailInput)}
                        placeholder={FLABEL().RECEIPT_ENTER_EMAIL}
                    />
                </div>
                 <span className={style.errorTextColor}>{error ? error : <>&nbsp;</>}</span>
                <div className={cn('w-100', style.emailbuttoncontainer)}>
                    <button
                        onClick={() => setPopup(null)}
                        className={cn('w-35', style.emailbtn, style.emailcancelbtn)}
                    >
                        {FLABEL().RECEIPT_CANCEL}
                    </button>
                    <button
                        onClick={handleDone}
                        className={cn('w-35', style.emailbtn, style.emaildonebtn)}
                    >
                        {FLABEL().RECEIPT_DONE}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EmailReceipt;